import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

/**
 * Keeps iframe /embed sessions on the embed route. Stylovyze auth fallbacks may
 * React-redirect to /forge/login or /login/inno; those routes load sign-in iframes
 * that Model blocks.
 */
function EmbedRouteGuard() {
  const history = useHistory();

  useEffect(() => {
    if (window.self === window.top) {
      return;
    }

    const embedPath = `${window.location.pathname}${window.location.search}`;

    const guardPath = () => {
      if (!window.location.pathname.startsWith('/embed')) {
        history.replace(embedPath);
      }
    };

    guardPath();
    const unlisten = history.listen((location) => {
      if (!location.pathname.startsWith('/embed')) {
        history.replace(embedPath);
      }
    });

    return unlisten;
  }, [history]);

  return null;
}

export default EmbedRouteGuard;
